<script>
export default {
	props: {
		megaMenuHorizontalId: String,
		transparent: Boolean,
		noCalculatedWidth: Boolean,
	},
	methods: {
		makeId(item) {
			if (item.selectType == 'category') return `category-${item.categoryId}`
			else if (item.selectType == 'brand') return `brand-${item.brandId}`
			else return `url-${item.name}-${item.url}`
		},
	},
	computed: {
		item() {
			return this.$srv('MegaMenuHorizontal').find((item) => this.makeId(item) == this.megaMenuHorizontalId)
		},
		widthStyle() {
			if (this.noCalculatedWidth || this.$ssr) return

			const offset = 100
			const width = window.innerWidth - offset

			if (this.$srv('AppBarConfig.type') === 'round') {
				return {
					width: '100%',
					'max-width': '1200px',
					left: '50%',
					marginLeft: '-600px',
				}
			}

			return {
				width: `${width}px`,
				'margin-left': `${width / -2}px`,
				left: '50%',
			}
		},
		submenuStyle() {
			let result = {}

			if (this.item.img) {
				const { src } = this.$media(this.item.img)
				result.backgroundImage = `url('${src}')`
				result.backgroundPosition = 'right bottom'
				result.backgroundRepeat = 'no-repeat'
				result.backgroundSize = 'contain'
			}

			return result
		},
		text() {
			const { selectType } = this.item
			return selectType == 'category'
				? this.item.category.name
				: selectType == 'brand'
				? this.item.brand.name
				: this.item.name
		},
	},
}
</script>

<template>
	<AppBar-MenuWithActivator
		v-if="item"
		:button-props="{
			text,
		}"
		:submenu-style="submenuStyle"
		:width-style="widthStyle"
		:transparent="transparent"
		:link="item.url"
	>
		<CategoriesMegaMenu-CategoryTitle v-if="!item.disableTitle" :item="item" />
		<CategoriesMenu :items="item.ordered" :link="item.dropdownImgLink" />
	</AppBar-MenuWithActivator>
</template>

